import httpService, { DEVELOPMENT } from '@/helper/httpService';
// eslint-disable-next-line
import de from 'vee-validate/dist/locale/de';

const EmptyPdf = "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/Ohne.pdf";

const maklerService = {
  title: "Maklerservice",
  type: "Makler",
  phone: "(+49) 02 21 / 37 638 - 92",
  phoneClickable: '+492213763892',
  fax: "(+49) 02 21 / 37 638 - 73 92",
  email: "maklerservice@dmb-rechtsschutz.de",
  time: "Montag - Freitag 8:00 - 18:00 Uhr"
};

const rechtService = {
  title: "DMB RECHT-Hotline",
  type: "DMB RECHT",
  subtitle: "Bei Rechtsfragen Ihrer Kunden",
  phone: "(+49) 08 00 / 36 27 32 48*",
  phoneClickable: '+4980036273248',
  time: "Montag - Freitag 8:00 - 20:00 Uhr",
  footnote: "deutschlandweit gebührenfrei"
};

const state = {
  StartseiteNews: null,
  StartseiteAuszeichnungen: null,
  ProduktePrivat: {
    "sectionTitle": "Privatkunden-RS",
    "items": [
      {
        "link": "/wp-content/uploads/tarif2026/DMB_RS_Leistungsvergleich_EXPERT_PRESTIGE_01_2026.pdf",
        "title": "Leistungsvergleich Privat-Rechtsschutz"
      },
    ]
  },
  ProduktePrivatWeitere: {
    "sections": [
      {
        "sectionTitle": "Weitere Unterlagen",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Deckungsnote_Privat_2026_L1_interaktiv.pdf",
            "title": "Deckungsauftrag Privatkunden-RS"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf",
            "title": "Kundeninfo AVI + ARB 2026"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_SuS_261.pdf",
            "title": "Kundeninfo AVI + ARB Schnell & Sicher 2026"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Leistungsvergleich_EXPERT_PRESTIGE_01_2026.pdf",
            "title": "Leistungsvergleich Rechtsschutz für Privatkunden"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_YOLIG_261.pdf",
            "title": "Kundeninfo AVI + ARB YOLIG 2026"
          }
        ]
      }
    ]
  },
  ProdukteGewerbe: {
    "sections": [
      {
        "sectionTitle": "Anträge/ARB/iPID",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Deckungsauftrag-Gewerbekunden-Rechtsschutz_2026_interaktiv.pdf",
            "title": "Deckungsauftrag Gewerbe-RS"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf",
            "title": "Kundeninfo AVI + ARB 2026"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_KOMPEX_EB_01_2026.pdf",
            "title": "KOMPEX Leistungen und Beiträge"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_KOMPEX_Folder_01_2026.pdf",
            "title": "KOMPEX Produktinformationen"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Verkaufshilfe_KOMPEX_Grafik_01_2026.pdf",
            "title": "Verkaufshilfe Geschäftskunden Grafik"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/gewerbe/dmb_recht_forderungshilfe_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Geschäftskunden"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/gewerbe/dmbrs-deckungsauftrag-vereine-0120.pdf",
            "title": "Deckungsauftrag Vereins-RS"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Vereins-RS_Maklerinfo_01_2026.pdf",
            "title": "Maklerinformation Vereins-Rechtsschutz"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/gewerbe/dmb_recht_forderungshilfe_fuer_vereine_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Vereine"
          }
        ]
      }
    ]
  },
  ProdukteKomedex: {
    "sections": [
      {
        "sectionTitle": "Anträge/ARB/iPID",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_KOMedEX_EB_01_2026.pdf",
            "title": "KOMedEX Leistungsmerkmale und Beiträge"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_KOMedEX_Folder_01_2026.pdf",
            "title": "KOMedEX Produktinformationen"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf",
            "title": "Kundeninfo AVI + ARB 2026"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/gewerbe/dmb_recht_forderungshilfe_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Geschäftskunden"
          }
        ]
      }
    ]
  },
  ProdukteAgromex: {
    "sections": [
      {
        "sectionTitle": "Anträge/ARB/iPID",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AGROMEX_01_2026.pdf",
            "title": "AGROMEX Highlights und Tarifblatt"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf",
            "title": "Kundeninfo AVI + ARB 2026"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/gewerbe/dmb_recht_forderungshilfe_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Geschäftskunden"
          }
        ]
      }
    ]
  },
  ProdukteService: {
    "sections": [
      {
        "sectionTitle": "Service für Kunden",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_DMB_RECHT_Serviceleistungen_01_2026.pdf",
            "title": "DMB RECHT Serviceleistungen"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/dmb_rs_infoblatt_vorsorge-assistent_2024.pdf",
            "title": "Rechtliche persönliche Vorsorge"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/dmb_rs_infoblatt_vorsorge-_und_testamentsassistent_2025.pdf",
            "title": "Rechtliche Vorsorge mit Testamentserstellung"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Cyber-RS_01_2026.pdf",
            "title": "Cyber-Check für mehr Sicherheit im Netz"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/Gefahr-aus-dem-Netz.pdf",
            "title": "Psychologische Soforthilfe nach Cyber-Mobbing "
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/dmb_recht_forderungshilfe_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Geschäftskunden"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/dmb_rs_dmb_recht_forderungshilfe_fuer_vermieter_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für private Vermieter"
          },
          {
            "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/produkte/service/dmb_recht_forderungshilfe_fuer_vereine_info_vertriebspartner_06_2025.pdf",
            "title": "DMB RECHT Forderungshilfe für Vereine"
          }
        ]
      }
    ]
  },
  VertriebRechtAktuell: null,
  VertriebSEPA: {
    "sections": [{
            "sectionTitle": "SEPA",
            "items": [{
                    "link": "/wp-content/uploads/2022/11/SEPA-Info.pdf",
                    "title": "SEPA Informationen"
                }, {
                    "link": "/wp-content/uploads/2022/11/SEPA-Basis-Mandat.pdf",
                    "title": "SEPA Basismandat"
                }
            ]
        }
    ]
},
  VertriebVerkaufshilfen: {
    "sections": [
      {
        "sectionTitle": "Verkaufshilfe/Schadenbeispiele",
        "items": [
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_YOLIG_Kundenbroschuere_01_2026.pdf",
            "title": "Kundenbroschüre YOLIG "
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_YOLIG_Highlight-Blatt_Vertriebspartner_01_2026.pdf",
            "title": "YOLIG Highlight-Blatt"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_YOLIG_Tarifblatt_Vertriebspartner_01_2026.pdf",
            "title": "YOLIG Tarifblatt"
          },
          {
            "link": "/wp-content/uploads/historie/dmb_rs_service___produkte_kundenbroschuere_05_2022.pdf",
            "title": "Kundenbroschüre Service + Produkte"
          },
          {
            "link": "/wp-content/uploads/historie/dmb_rs_unternehmen_kundenbroschuere_05_2022.pdf",
            "title": "Kundenbroschüre Unternehmen "
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Verkaufshilfe_Privatkunden_Grafik_01_2026.pdf",
            "title": "Verkaufshilfe Privatkunden Grafik"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Verkaufshilfe_Privatkunden_Tabelle_01_2026.pdf",
            "title": "Verkaufshilfe Privatkunde Tabelle"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Leistungsvergleich_EXPERT_PRESTIGE_01_2026.pdf",
            "title": "Leistungsvergleich Privatkunden"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Cyber-RS_01_2026.pdf",
            "title": "Cyber-Rechtsschutz Highlights"
          },
          {
            "link": "/wp-content/uploads/historie/Cyberrisiko.pdf",
            "title": "Cyberrisiko: Rechtsschutz-Thema 05/2018"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_KOMPEX_Folder_01_2026.pdf",
            "title": "Rechtsschutz für Geschäftskunden"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_Verkaufshilfe_KOMPEX_Grafik_01_2026.pdf",
            "title": "Verkaufshilfe Geschäftskunden Grafik"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_DMB_RECHT_Serviceleistungen_01_2026.pdf",
            "title": "DMB RECHT Serviceleistungen"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf",
            "title": "Kundeninformationen/ ARB 2026"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_SuS_261.pdf",
            "title": "Kundeninformationen/ ARB Schnell & Sicher 2026"
          },
          {
            "link": "/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_YOLIG_261.pdf",
            "title": "Kundeninfo AVI + ARB YOLIG 2026"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb_241.pdf",
            "title": "Kundeninformationen/ ARB 2024"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb-s_s_241.pdf",
            "title": "Kundeninformationen/ ARB Schnell & Sicher 2024"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb-yolig_241.pdf",
            "title": "Kundeninfo AVI + ARB YOLIG 2024"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb_221_60s-final.pdf",
            "title": "Kundeninformationen/ ARB 2022"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb-sus_221.pdf",
            "title": "Kundeninformationen/ ARB Schnell & Sicher 2022"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb-yolig_229.pdf",
            "title": "Kundeninformationen/ ARB YOLIG 2022"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb_201.pdf",
            "title": "Kundeninformationen/ ARB 2020"
          },
          {
            "link": "/wp-content/uploads/historie/dmb_rs_avi-arb-s_s_201.pdf",
            "title": "Kundeninformationen/ ARB Schnell & Sicher 2020"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb_181.pdf",
            "title": "Kundeninformationen/ ARB 2018"
          },
          {
            "link": "/wp-content/uploads/historie/dmb-rs_avi-arb_171.pdf",
            "title": "Kundeninformationen/ ARB 2017"
          }
        ]
      }
    ]
  },
  VertriebMaklerservice: {
    service: {
      sectionTitle: 'Service für Makler',
      persons: [
        {
          name: 'Nadine Biermann',
          rolle: 'Maklerservice & Key Account\nLandwirtschafts-Rechtsschutz',
          phone: '(+49) 02 21 / 37 638 - 12',
          phoneClickable: '+492213763812',
          fax: '',
          email: '',
          imgSrc: '/Biermann2019.jpg',
        },
        {
          name: 'Ronald Doll',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 14',
          phoneClickable: '+492213763814',
          fax: '',
          email: '',
          imgSrc: '/Doll2020.jpg',
        },
        {
          name: 'Dusica Kähler',
          rolle: 'Maklerservice & Key Account',
          phone: '(+49) 02 21 / 37 638 - 71',
          phoneClickable: '+492213763871',
          fax: '',
          email: '',
          imgSrc: '/Kaehler2019.jpg',
        },
        {
          name: 'Susann Klimpel-Hildebrandt',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 57',
          phoneClickable: '+492213763844',
          fax: '',
          email: '',
          imgSrc: '/Klimpel-Hildebrandt2019.jpg',
        },
        {
          name: 'Julia Köhler',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 29',
          phoneClickable: '+492213763829',
          fax: '',
          email: '',
          imgSrc: '/Koehler2020.jpg',
        },
        {
          name: 'Jürgen Kretschmer',
          rolle: 'Maklerservice & Key Account',
          phone: '(+49) 02 21 / 37 638 - 59',
          phoneClickable: '+492213763859',
          fax: '',
          email: '',
          imgSrc: '/Kretschmer2022.jpg',
        },
        {
          name: 'Markus Lauffs',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 39',
          phoneClickable: '+492213763839',
          fax: '',
          email: '',
          imgSrc: '/Lauffs2019.jpg',
        },
        {
          name: 'Andreas Nothhelfer',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 51',
          phoneClickable: '+492213763851',
          fax: '',
          email: '',
          imgSrc: '/',
        },
        {
          name: 'Kim Cara Schmidt',
          rolle: 'Maklerservice & Key Account',
          phone: '(+49) 02 21 / 37 638 - 7710',
          phoneClickable: '+49221376387710',
          fax: '',
          email: '',
          imgSrc: '/Schmidt2025.jpg',
        },
        {
          name: 'Michael Streckert',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 28',
          phoneClickable: '+492213763828',
          fax: '',
          email: '',
          imgSrc: '/Streckert2019.jpg',
        },
        {
          name: 'Piotr Tobola',
          rolle: 'Maklerservice',
          phone: '(+49) 02 21 / 37 638 - 43',
          phoneClickable: '+492213763843',
          fax: '',
          email: '',
          imgSrc: '/Tobola2019.jpg',
        },
        {
          name: 'Viktoria Jiménez García',
          rolle: 'Leiterin\nPartner- & Kundenservice\nKey Account & Vertriebsunterstützung\n',
          phone: '(+49) 02 21 / 37 638 - 21',
          phoneClickable: '+492213763821',
          fax: '',
          email: '',
          imgSrc: '/Jimenez2022.jpg',
        }
      ]
    },
    vorOrt: {
      sectionTitle: 'Maklerbetreuung vor Ort',
      persons: [
        {
          name: 'Peter Hofmann',
          rolle: 'Vertriebsleiter West',
          phone: '0173 / 40 38 540',
          phoneClickable: '+491734038540',
          email: 'peter.hofmann@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/peter-hofmann-dmb-rechtsschutz',
          imgSrc: '/Peter_Hofmann_2025.jpg',
          cssClass: 'profile--img',
        },
        //        {
        //          name: '',
        //          rolle: '',
        //          phone: '',
        //          phoneClickable: '',
        //          email: '',
        //          termin: '',
        //          imgSrc: '',
        //          cssClass: 'profile--img',
        //        },
        {
          name: 'Candy Huster',
          rolle: 'Manager Digitaler Vertrieb',
          phone: '0171 / 97 37 656',
          phoneClickable: '+491719737656',
          email: 'candy.huster@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/candy-huster-dmb-rechtsschutz',
          imgSrc: '/Candy_Huster_2025.jpg',
          cssClass: 'profile--img',
        },
        {
          name: 'Antje Lier',
          rolle: 'Vertriebsleiterin Ost',
          phone: '0160 / 99 79 63 55',
          phoneClickable: '+4916099796355',
          email: 'antje.lier@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/antje-lier-dmb-rechtsschutz',
          imgSrc: '/Antje_Lier_2025.jpg',
          cssClass: 'profile--img',
        },
        {
          name: 'Kolja Wiekhorst',
          rolle: 'Vertriebsleiter Nord',
          phone: '0171 / 777 01 86',
          phoneClickable: '+491717770186',
          email: 'kolja.wiekhorst@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/kolja-wiekhorst-dmb-rechtsschutz',
          imgSrc: '/Kolja_Wiekhorst_2025.jpg',
          cssClass: 'profile--img',
        },
        {
          name: 'Sven Wiltsch',
          rolle: 'Vertriebsleiter Süd',
          phone: '0171 / 777 11 44',
          phoneClickable: '+491717771144',
          email: 'sven.wiltsch@dmb-rechtsschutz.de',
          termin: 'https://calendly.com/sven-wiltsch-dmb-rechtsschutz',
          imgSrc: '/Sven_Wiltsch_2025.jpg',
          cssClass: 'profile--img',
        },
        {
          name: 'Milan Jarosch',
          rolle: 'Leiter Vertrieb',
          phone: '0171 / 777 66 26',
          phoneClickable: '+491717776626',
          email: 'milan.jarosch@dmb-rechtsschutz.de',
          imgSrc: '/Milan_Jarosch_2025.jpg',
          cssClass: 'profile--img',
        }
      ],
    }
  },
  VertriebMaklerServiceSidebar: [
    maklerService,
    {
      title: "Anträge einreichen",
      type: "Antrag",
      phone: "",
      fax: "(+49) 02 21 / 37 638 - 73 14",
      email: "antrag@dmb-rechtsschutz.de"
    },
    rechtService,
    {
      title: "Fragen zu Schäden",
      type: "Schaden",
      phone: "(+49) 02 21 / 37 638 - 93",
      phoneClickable: '+492213763893',
      fax: "",
      email: "schaden@dmb-rechtsschutz.de"
    }
  ],
  AboutUnternehmen: null,
  AboutUnternehmenDownloads: null,
  AboutUnternehmenMaklerBox: maklerService,
  AboutPresse: null,
  AboutAuszeichnungenUnternehmen: null,
  AboutAuszeichnungenUnternehmenBadges: null,
  AboutAuszeichnungenProdukte: null,
  AboutAuszeichnungenProdukteBadges: null,
  ARB: {
    sectionTitle: "ARB",
    items: [
      {
        title: "ARB",
        link: '/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_261.pdf'
      }
    ]
  },
  ARB_SUS: {
    sectionTitle: "ARB Schnell & Sicher",
    items: [
      {
        title: "ARB",
        link: '/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_SuS_261.pdf'
      }
    ]
  },
  ARB_YOLIG: {
    sectionTitle: "ARB YOLIG",
    items: [
      {
        title: "ARB YOLIG",
        link: '/wp-content/uploads/tarif2026/DMB_RS_AVI-ARB_YOLIG_261.pdf'
      }
    ]
  },
  PI_Standard: {
    sectionTitle: "Produktinformationen Standard",
    items: [
      {
        title: "Produktinformationen Standard",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PIB_Standard_2026.pdf'
      }
    ]
  },
  PI_EXPERT: {
    sectionTitle: "Produktinformationen EXPERT",
    items: [
      {
        title: "Produktinformationen EXPERT",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PIB_EXPERT_2026.pdf'
      }
    ]
  },
  PI_SUS: {
    sectionTitle: "Produktinformationen Schnell & Sicher",
    items: [
      {
        title: "Produktinformationen  Schnell & Sicher",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PIB_SchnelluSicher_2026.pdf'
      }
    ]
  },
  PI_PRESTIGE: {
    sectionTitle: "Produktinformationen PRESTIGE",
    items: [
      {
        title: "Produktinformationen PRESTIGE",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PIB_PRESTIGE_2026.pdf'
      }
    ]
  },
  PI_YOLIG: {
    sectionTitle: "Produktinformationen YOLIG",
    items: [
      {
        title: "Produktinformationen YOLIG",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PIB_YOLIG_2026.pdf'
      }
    ]
  },
  HL_Standard: {
    sectionTitle: "Highlightblatt Standard",
    items: [
      {
        title: "Highlight-Blatt Standard",
        link: '/wp-content/uploads/tarif2026/DMB_RS_Standard_Highlight-Blatt_01_2026.pdf'
      }
    ]
  },
  HL_EXPERT: {
    sectionTitle: "Highlightblatt EXPERT",
    items: [
      {
        title: "Highlight-Blatt EXPERT",
        link: '/wp-content/uploads/tarif2026/DMB_RS_EXPERT_Highlight-Blatt_01_2026.pdf'
      }
    ]
  },
  HL_SUS: {
    sectionTitle: "Highlightblatt Schnell & Sicher",
    items: [
      {
        title: "Highlightblatt Schnell & Sicher",
        link: '/wp-content/uploads/tarif2026/DMB_RS_Schnell_u_Sicher_Highlight-Blatt_01_2026.pdf'
      }
    ]
  },
  HL_PRESTIGE: {
    sectionTitle: "Highlightblatt PRESTIGE",
    items: [
      {
        title: "Highlight-Blatt PRESTIGE",
        link: '/wp-content/uploads/tarif2026/DMB_RS_PRESTIGE_Highlight-Blatt_01_2026.pdf'
      }
    ]
  },
  HL_YOLIG: {
    sectionTitle: "Highlightblatt YOLIG",
    items: [
      {
        title: "Highlight-Blatt YOLIG",
        link: '/wp-content/uploads/tarif2026/DMB_RS_YOLIG_Highlight-Blatt_Vertriebspartner_01_2026.pdf'
      }
    ]
  },
  nachweis_vorversicherer: {
    "sectionTitle": "Erklärung Nachweis Vorversicherer",
    "items": [
      {
        "link": "https://www.dmb-rechtsschutz.de/dmbrs/fileadmin/mp/pdf/dokumente/dmb-rs_schnell_und_sicher_erklaerung_nachweis_vorversicherer_1120.pdf",
        "title": "Schnell & Sicher Erklärung Nachweis Vorversicherer"
      }
    ]
  },
  EmptyPdf: EmptyPdf
};

const actions = {
  populateContent({ commit, state }, paths) {
    let requests = [];
    paths.map(path => {
      if (state[path] === null) {
        requests.push(httpService.getStaticContent(path)
          .then(result => commit("updateStaticContent", {
            path,
            newContent: result
          })));
      }
    });
    return Promise.all(requests);
  },
};

const mutations = {
  updateStaticContent(state, { path, newContent }) {
    if (Array.isArray(newContent) && newContent[0]?.content?.rendered) {
      if (path === "StartseiteNews") {
        state[path] = convertRendered(newContent, "sectionTitle", "NEWS", "title", "text", "link", "url");
      } else if (path === "StartseiteAuszeichnungen") {
        state[path] = convertRendered(newContent, "sectionTitle", "Presse", "src", "url", "link", "url");
      } else if (path === "AboutPresse") {
        let tmpAboutPresse = {"sections": [{"sectionTitle": "", "items": [] }]};
        tmpAboutPresse.sections[0].items = (convertRendered(newContent, "", "", "title", "text","link","url")).items;
        state[path] = tmpAboutPresse;
      } else if (path === "AboutUnternehmenDownloads") {
        state[path] = convertAboutUnternehmenDownloads(newContent);
      } else if (path === "AboutUnternehmen") {
        state[path] = convertAboutUnternehmen(newContent);
      } else if (path === "VertriebRechtAktuell") {
        state[path] = convertRendered(newContent, "sectionTitle", "Recht: aktuell", "title", "text", "link", "url");
      } else if (path === "AboutAuszeichnungenUnternehmen") {
        let tmpAuszeichnungenUnternehmen = {"sections": [{"sectionTitle": "", "items": [] }]};
        tmpAuszeichnungenUnternehmen.sections[0].items = (convertRendered(newContent, "", "", "title", "text","link",null)).items;
        state[path] = tmpAuszeichnungenUnternehmen;
      } else if (path === "AboutAuszeichnungenProdukte") {
        state[path] = convertAboutAuszeichnungenText(newContent);
      } else if (path === "AboutAuszeichnungenUnternehmenBadges" || path === "AboutAuszeichnungenProdukteBadges") {
        state[path] = convertAboutAuszeichnungenBadges(newContent);
      }
      // for debugging content conversion issues, uncomment the following line
      // console.log(`Converted content for ${path}:\n${JSON.stringify(state[path], null, 2)}`);
    } else {
      state[path] = newContent;
      console.warn(`Unexpected content format for ${path}:`, newContent);
    }
  }
};

function decodeHtmlEntities(text) {
  if (typeof text !== 'string') {
    return '';
  }

  return text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&#038;|&amp;/gi, '&')
    .replace(/&#8222;|&bdquo;|&#8220;|&#8221;|&ldquo;|&rdquo;|&quot;/gi, '"')
    .replace(/&#8211;|&ndash;/gi, '-')
    .trim();
}

function convertAboutUnternehmenDownloads(backendContent) {
  const rendered = Array.isArray(backendContent)
    ? backendContent?.[0]?.content?.rendered
    : backendContent?.content?.rendered;

  const result = {
    title: "Downloads",
    type: "link",
    links: []
  };

  if (!rendered || typeof rendered !== 'string') {
    return result;
  }

  const paragraphMatches = rendered.match(/<p[^>]*>[\s\S]*?<\/p>/gi) || [];
  result.links = paragraphMatches
    .map((paragraphHtml) => {
      const plain = decodeHtmlEntities(
        paragraphHtml
          .replace(/^<p[^>]*>/i, '')
          .replace(/<\/p>$/i, '')
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<[^>]+>/g, '')
      );

      const lines = plain
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean);

      if (!lines.length) {
        return null;
      }

      const title = (lines[0] || '').replace(/^#\s*/, '').trim();
      const subtitleRaw = (lines[1] || '').replace(/^##\s*/, '').trim();
      const linkRaw = lines.find(line => /^(https?:\/\/|\/)/i.test(line)) || '';

      if (!title || !linkRaw) {
        return null;
      }

      const item = {
        title,
        link: normalizeLink(linkRaw)
      };

      if (subtitleRaw && subtitleRaw !== '-') {
        item.subtitle = subtitleRaw;
      }

      return item;
    })
    .filter(Boolean);

  return result;
}

function convertAboutUnternehmen(backendContent) {
  const rendered = Array.isArray(backendContent)
    ? backendContent?.[0]?.content?.rendered
    : backendContent?.content?.rendered;

  const result = {
    content: {
      sections: []
    }
  };

  if (!rendered || typeof rendered !== 'string') {
    return result;
  }

  const paragraphMatches = rendered.match(/<p[^>]*>[\s\S]*?<\/p>/gi) || [];
  result.content.sections = paragraphMatches
    .map((paragraphHtml) => {
      // Keep anchors and images before stripping tags
      const anchorMatches = Array.from(
        paragraphHtml.matchAll(/<a[^>]*href=["']([^"']+)["'][^>]*>([\s\S]*?)<\/a>/gi)
      );
      const imageMatches = Array.from(
        paragraphHtml.matchAll(/<img[^>]*src=["']([^"']+)["'][^>]*>/gi)
      );

      const anchors = anchorMatches.map(([, href, innerHtml]) => ({
        href: href,
        text: decodeHtmlEntities(innerHtml.replace(/<[^>]+>/g, ''))
      }));
      const imageSrcs = imageMatches.map(([, src]) => normalizeLink(src.trim()));

      const plain = decodeHtmlEntities(
        paragraphHtml
          .replace(/^<p[^>]*>/i, '')
          .replace(/<\/p>$/i, '')
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<[^>]+>/g, '')
      );

      const lines = plain
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean);

      if (!lines.length) {
        return null;
      }

      const sectionTitle = (lines[0] || '').replace(/^#\s*/, '').trim();
      if (!sectionTitle) {
        return null;
      }

      const contentLines = lines.slice(1);
      const section = {
        sectionTitle,
        items: []
      };

      // The BFV entry combines plain text, anchor and image.
      const primaryAnchor = anchors[0] || null;
      const primaryImage = imageSrcs[0] || '';
      const specialItemIndex = primaryAnchor && primaryImage
        ? contentLines.findIndex(line => line !== primaryAnchor.text && line.includes(primaryAnchor.text))
        : -1;

      contentLines.forEach((line, index) => {
        if (primaryAnchor && line === primaryAnchor.text) {
          return;
        }

        if (index === specialItemIndex) {
          // Rebuild BFV item so the text stays in the bullet while the logo remains renderable.
          const titlePrefix = line.includes(primaryAnchor.text)
            ? line.split(primaryAnchor.text)[0]
            : line;

          section.items.push({
            link: primaryImage,
            title: titlePrefix,
            subtitle: `${line} <a target='_blank' href='${primaryAnchor.href}'>${primaryAnchor.text}</a>`
          });
          return;
        }

        // Regular bullet items render as plain text with empty PDF link.
        section.items.push({
          link: EmptyPdf,
          title: line
        });
      });

      return section.items.length ? section : null;
    })
    .filter(Boolean);

  return {
    content: result.content
  };
}

function convertAboutAuszeichnungenText(backendContent) {
  const rendered = Array.isArray(backendContent)
    ? backendContent?.[0]?.content?.rendered
    : backendContent?.content?.rendered;

  if (!rendered || typeof rendered !== 'string') {
    return { sections: [] };
  }
  const sections = [];
  let currentSection = null;

  const toPlainParagraphText = (paragraphHtml) => decodeHtmlEntities(
    paragraphHtml
      .replace(/^<p[^>]*>/i, '')
      .replace(/<\/p>$/i, '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<[^>]+>/g, '')
  );

  const isSectionParagraph = (paragraphHtml) => {
    const marker = /^<p[^>]*>\s*#/i.test(paragraphHtml) ? '<p>#' : '';
    return /<p>#/i.test(marker);
  };

  const pushCurrentSection = () => {
    if (currentSection?.items?.length) {
      sections.push(currentSection);
    }
  };

  const blockMatches = rendered.match(/<p[^>]*>[\s\S]*?<\/p>/gi) || [];

  blockMatches.forEach((blockHtml) => {
    const paragraphHtml = blockHtml;
    const plainParagraph = toPlainParagraphText(paragraphHtml);
    const lines = plainParagraph
      .split('\n')
      .map(line => line.trim())
      .filter(Boolean);

    if (!lines.length) {
      console.log(`[convertAboutAuszeichnungenText] Paragraph ignored (no output): ${paragraphHtml}`);
      return;
    }

    let itemStartIndex = 0;

    if (isSectionParagraph(paragraphHtml)) {
      const firstLine = lines[0] || '';
      const sectionMarkerMatch = firstLine.match(/^#\s*(.+)$/);

      const sectionTitle = sectionMarkerMatch ? sectionMarkerMatch[1].trim() : '';
      currentSection = { sectionTitle, items: [] };
      itemStartIndex = 1;
    } else if (!currentSection) {
      currentSection = { sectionTitle: '', items: [] };
    }

    lines.slice(itemStartIndex)
      .map(line => line.replace(/^#\s*/, '').trim())
      .filter(line => line && !/^(https?:\/\/|\/|-)/i.test(line))
      .forEach((title) => {
        currentSection.items.push({ title });
      });
      pushCurrentSection();
  });


  return {
    sections
  };
}

function convertAboutAuszeichnungenBadges(backendContent) {
  const rendered = Array.isArray(backendContent)
    ? backendContent?.[0]?.content?.rendered
    : backendContent?.content?.rendered;

  if (!rendered || typeof rendered !== 'string') {
    return [];
  }

  const paragraphMatches = rendered.match(/<p[^>]*>[\s\S]*?<\/p>/gi) || [];
  const badgesFromParagraphs = paragraphMatches
    .map((paragraphHtml) => {
      const plain = decodeHtmlEntities(
        paragraphHtml
          .replace(/^<p[^>]*>/i, '')
          .replace(/<\/p>$/i, '')
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<[^>]+>/g, '')
      );

      const lines = plain
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean);

      if (!(lines[0] || '').startsWith('#')) {
        return null;
      }

      const payloadLines = lines.slice(1);
      const srcRaw = payloadLines.find(line => /^(https?:\/\/|\/)/i.test(line));
      if (!srcRaw) {
        return null;
      }

      const srcIndex = payloadLines.indexOf(srcRaw);
      const trailingLines = payloadLines.slice(srcIndex + 1).filter(Boolean);
      const linkCandidate = trailingLines[0] || '';
      const isNoLinkMarker = /^(-|&#8211;|&ndash;|–)$/i.test(linkCandidate);

      const badge = { src: normalizeLink(srcRaw) };
      if (linkCandidate && !isNoLinkMarker && /^(https?:\/\/|\/)/i.test(linkCandidate)) {
        badge.link = normalizeLink(linkCandidate);
      }

      return badge;
    })
    .filter(Boolean);

  if (badgesFromParagraphs.length) {
    return badgesFromParagraphs;
  }

  const container = document.createElement('div');
  container.innerHTML = rendered;

  return Array.from(container.querySelectorAll('img'))
    .map(img => {
      const src = img.getAttribute('src') || img.getAttribute('data-src') || '';
      if (!src) {
        return null;
      }
      const anchor = img.closest('a[href]');
      const badge = {
        src: normalizeLink(src.trim())
      };
      if (anchor?.getAttribute('href')) {
        badge.link = normalizeLink(anchor.getAttribute('href').trim());
      }
      return badge;
    })
    .filter(Boolean);
}

function convertRendered(backendContent, rootElementName, rootElementValue, child1Name, child1Type, child2Name, child2Type) {
  const rendered = Array.isArray(backendContent)
    ? backendContent?.[0]?.content?.rendered
    : backendContent?.content?.rendered;

  if (!rendered || typeof rendered !== 'string') {
    return buildRenderedResult(rootElementName, rootElementValue, []);
  }

  const paragraphMatches = rendered.match(/<p>[\s\S]*?<\/p>/gi) || [];
  const items = paragraphMatches
    .map(paragraph => {
      const plain = decodeHtmlEntities(
        paragraph
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<[^>]+>/g, '')
      );

      if (!plain) {
        return null;
      }

      const lines = plain
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean);

      if (!lines.length) {
        return null;
      }

      const textLines = lines
        .map(line => line.replace(/^#\s*/, '').trim())
        .filter(line => line && !/^(https?:\/\/|\/|-)/i.test(line));
      const urlLines = lines
        .filter(line => /^(https?:\/\/|\/)/i.test(line))
        .map(normalizeLink);

      const source = {
        text: textLines[0] ?? '',
        urls: urlLines
      };

      const firstValue = getValueByType(child1Type, source, 0);
      const secondValue = getValueByType(child2Type, source, child1Type === child2Type ? 1 : 0);

      if (firstValue == null && secondValue == null) {
        return null;
      }

      return {
        [child1Name]: firstValue,
        [child2Name]: secondValue
      };
    })
    .filter(Boolean);

  return buildRenderedResult(rootElementName, rootElementValue, items);
}

function buildRenderedResult(rootElementName, rootElementValue, items) {
  const result = { items };

  if (rootElementName) {
    result[rootElementName] = rootElementValue;
  }

  return result;
}

function getValueByType(type, source, urlIndex = 0) {
  if (type === 'text') {
    return source.text || null;
  }
  if (type === 'url') {
    return source.urls[urlIndex]; // ?? EmptyPdf;
  }
  return source[type] ?? null;
}

function normalizeLink(link) {
  if (!link || link === '-') {
    return '';
  }

  if (/^https?:\/\//i.test(link)) {
    return link;
  }

  if (DEVELOPMENT && link.startsWith('/')) {
    return `https://test.dmb-rechtsschutz.de${link}`;
  }

  return `${link}`;
}

export default {
  state,
  actions,
  mutations
};
